// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#rootVM > .panel .panel-body .form-group {\r\n\tdisplay: flex;\r\n\talign-items: center;\n}\n#rootVM > .panel .panel-body .form-group label {\r\n\tmargin-top: 5px;\n}\n#rootVM > .panel .panel-body .form-group input {\r\n\tmax-width: 200px;\r\n\tmargin-left: 15px;\n}\r\n", ""]);
// Exports
module.exports = exports;
